import { render } from "./RecallLeave.vue?vue&type=template&id=44c390fc&scoped=true"
import script from "./RecallLeave.vue?vue&type=script&lang=js"
export * from "./RecallLeave.vue?vue&type=script&lang=js"

import "./RecallLeave.vue?vue&type=style&index=0&id=44c390fc&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c390fc"]])

export default __exports__